import { useAnalyticContext } from '@application/analytic/analytic_context.provider';
import { withTranslation } from '@application/i18n/with_translation';
import { DialogAlert } from '@cellula/react';

interface Above110DialogProps {
	isOpen: boolean;
	onClose(): void;
	onContinue(): void;
}

export function Above110Dialog({ isOpen, onClose, onContinue }: Above110DialogProps) {
	const analytic = useAnalyticContext();

	function handleSuccess() {
		analytic.trackEvent('Above 110 Dialog Alert', 'Confirmed age');
		onContinue();
	}

	function handleOpenChange(open = false) {
		if (open) {
			analytic.trackEvent('Above 110 Dialog Alert', 'Opened');
		}

		if (!open) {
			analytic.trackEvent('Above 110 Dialog Alert', 'Aborted');
			onClose();
		}
	}

	return (
		<DialogAlert
			isOpen={isOpen}
			header={withTranslation('View.RedRobin.ScreenWhoIsRespondant.Above110Dialog.Header')}
			description={withTranslation('View.RedRobin.ScreenWhoIsRespondant.Above110Dialog.Description')}
			abortText={withTranslation('View.RedRobin.ScreenWhoIsRespondant.Above110Dialog.AbortText')}
			successText={withTranslation('View.RedRobin.ScreenWhoIsRespondant.Above110Dialog.SuccessText')}
			successButtonVariant='primary'
			onSuccess={handleSuccess}
			onOpenChange={handleOpenChange}
		/>
	);
}
